<template>
	<div class="ReReports">
		<div class="my-2">
			
			<div v-if="objReport" id="report-table" >
				<card class="tableReports">
					<div class="d-flex flex-wrap align-items-baseline pt-3 pb-2 pl-3" v-if="strTags && strTags !=''" style="background: rgb(1, 176, 224, 0.33);">
						<h6 class="mb-0 mr-2">Выбранные фильтры:</h6>
							<p>{{strTags}}</p>
					</div>	
					<table class="table tablesorter" v-html="reportTable" ></table>
					<!--
					<el-table
					:data="objReport.data" 
					style="width: 100%"
					:row-key="row => row.id"
					show-summary
					:summary-method="summary"
					:row-class-name="tableRowClassName"
					:row-style="tableRowClassName2"
					:span-method="colSpan"
					:height="tableHeight"
					sum-text="Всего"
					v-loading.fullscreen.lock="$GVO.fullscreenLoading"
					element-loading-text="Загрузка данных..."
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(0, 0, 0, 0.8)"	
					class="card card-plain mt-3 mt-xl-0">
						<el-table-column 
							v-for="(column, key) in objReport.fields" 
							:key="key"
							:label="column.name"
							:prop="key"
							:type="column.type"
							:formatter="formatter"
							:align="column.align || getAling(column.type)"
							
							>
						</el-table-column>
					</el-table>
					-->
				</card>
			</div>

		</div>
	</div>
</template>

<script>
	import { Select, Option, Tooltip, Button, Table, TableColumn } from 'element-ui';
	// import BaseTable from 'src/components/BaseTable.vue';

	export default {
		name: 'ReReports',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			[Tooltip.name]: Tooltip,
			[Button.name]: Button,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			// BaseTable
			
		},
		props: {
			flt: [Array,Object],
			tags: [Array,Object],
			strTags: String,
			objReport: Object,
			module: String,
			findId: {
				type: String,
				default: '',
			},
			keyParam: String,
			colspan: {
				type: Number,
				default:0,
			},
		},
		data () {
			return {
				ver: 1,
				fullscreenLoading: false,
				// reportAttributes:{value:'', catalog:'', options:[
				// 	{value: '1',label: 'Время обработки',},
				// 	{value: '2',label: 'Рекламные источники',},
				// 	{value: '3',label: 'Тип операций',},
				// 	{value: '4',label: 'Тип объекта',},
				// 	{value: '5',label: 'Подразделение',},
				// ], /*tagText:'Квартал',*/ elementType: 'select', value_default: ''},
				
			}
		},
		computed: {
			reportTable(){
				let html=['<thead>'];
				let content;
				html.push('<tr>');
				try{
					Object.keys(this.objReport.fields).forEach(field=>{
						html.push('<th style="text-align:'+(this.objReport.fields[field].align||'center')+'">'+this.objReport.fields[field].name+'</th>');
					})
					html.push('</tr>');
					html.push('</thead>');
					html.push('<tbody>');
					let data=[...this.objReport.data];
					let keys = Object.keys(this.objReport.fields)
					if(this.objReport.summary){
						this.objReport.summary._isSummary=true;
						this.objReport.summary._summaryLevel=9;
						data.push(this.objReport.summary);
					}

					data.forEach(trow=>{
						let colspan=0;
						let skip=[];
						if(trow._colspan){
							Object.keys(trow._colspan).forEach(start=>{
								for(let i=1;i<trow._colspan[start];i++){
									skip.push(Number(start)+i);
								}
							})
						}
						html.push('<tr'+(trow._isSummary?' class="summary-row summary-row-'+trow._summaryLevel+'"':'')+'>'); // class="summary-row-3"
						keys.forEach((field,i)=>{
							if(colspan>0) return;
							if(skip.indexOf(i)>-1) return;
							html.push('<td'+(trow._colspan && trow._colspan[i]?' colspan="'+trow._colspan[i]+'"':'')+' style="text-align:'+this.getAling(this.getCellType(this.objReport.fields[field],trow._isSummary),this.objReport.fields[field])+'">');
							content = trow[field] !== null ? this.formatter(null, this.objReport.fields[field], trow[field], false) : '-';
							html.push(trow[field + '_link'] 
							? `<a href="${trow[field + '_link']}" target="_report">${content}</a>` 
							: content);
							// html.push(trow[field]?this.formatter(null,this.objReport.fields[field],trow[field],false):'-');
							
							html.push('</td>');
						})
						html.push('</tr>');
					})
					html.push('</tbody>');
				}catch(e){
					console.error(e);
				}
				return html.join('');
			},
			tableHeight(){
				// временно закоментила, выдает высоту не по реальным данным, а на всю страницу
				return window.innerHeight;
			}
		},
		methods: {
			skipCell(cell,colspan,value){
				// console.log(cell,colspan, this.colspan);
				if(cell==0)this.colspan==0;
				if(this.colspan>1){
					this.colspan--;
					return false;
				}
				if(colspan){
					this.colspan = colspan;
				}
				return true;
			},
			onSave(){

			},
			onCancel(){

			},
			// reportToExcel(tableID, filename = ''){
			// 	// получение экселя простыми методами js -- не используем, сейчас используем библиотеку на пхп
			// 	var downloadLink;
			// 	var dataType = 'application/vnd.ms-excel';
			// 	var tableSelect = document.getElementById(tableID);
			// 	var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// 	// Specify file name
			// 	filename = filename?filename+'.xls':'excel_data.xls';

			// 	// Create download link element
			// 	downloadLink = document.createElement("a");

			// 	document.body.appendChild(downloadLink);

			// 	if(navigator.msSaveOrOpenBlob){
			// 	var blob = new Blob(['\ufeff', tableHTML], {
			// 	type: dataType
			// 	});
			// 	navigator.msSaveOrOpenBlob( blob, filename);
			// 	}else{
			// 	// Create a link to the file
			// 	downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

			// 	// Setting the file name
			// 	downloadLink.download = filename;
			// 	downloadLink.click();
			// 	}
			// },
			formatDate(dateStr){
				let time = new Date(dateStr);
				return time.toLocaleDateString('ru-RU', {
					year: 'numeric',
					month: 'long',
					day: 'numeric',
					})
			},
			formatSecondstoMinutes(t){
				let time = Math.round(t);

				let hours = Math.floor(time / 3600);
				let minutes = Math.floor((time - (hours * 3600)) / 60);
				let seconds = time - (hours * 3600) - (minutes * 60);
				if(hours>23) hours %= 24;
				// дополнительные нули для красоты
				if (hours < 10) { hours = "0" + hours; }
				if (minutes < 10) { minutes = "0" + minutes; }
				if (seconds < 10) { seconds = "0" + seconds; }

				return hours + ':' + minutes + ':' + seconds;
				
			},
			getAling(type,field){
				switch(type){
					case 'int':
					case 'time':
					case 'amount':
					case 'decimal':
					case 'percent':
						return 'right';
					default: return field.align || 'left';
				}
			},
			getCellType(column,isSummary){
				if(isSummary){
					if(column.summary_all_type) return column.summary_all_type
					else if ( column.summary_type )return column.summary_type;
				}
				return column.type;
			},
			formatter(row, column, value, isSummary) {
				if(value==undefined) return '';
				// console.log(row, column, value);
				let type = this.getCellType(column, isSummary);
				//работает только на колонке таблицы element.io
				switch(type){
					case 'datetime':
						return value?this.$GVO.convertDateTimeFromMysql(value):value;
					case 'date':
						// console.log('column.type ', column, value );
						return this.formatDate(value);
					case 'time':
						// console.log('column.type ', column, value );
						return this.formatSecondstoMinutes(value);
					case 'int':
						// console.log('column.type ', column, value );
						return this.$GVO.number_format(value,0,'.',' ');
					case 'amount':
						// console.log('column.type ', column, value );
						return this.$GVO.number_format(value,2,'.',' ');
					case 'decimal':
						// console.log('column.type ', column, value );
						return this.$GVO.number_format(value,1,'.',' ');
					case 'percent':
						// console.log('column.type ', column, value );
						return this.$GVO.number_format(value,1,'.',' ')+'%';
					default: return value;
				}
			},
			colSpan({ row, column, rowIndex, columnIndex }) {
				// if (columnIndex === 0) {
				// if (rowIndex % 2 === 0) {
				// 	return {
				// 	rowspan: 2,
				// 	colspan: 1
				// 	};
				// } else {
				// 	return {
				// 	rowspan: 0,
				// 	colspan: 0
				// 	};
				// }
				// }
				if(row._colspan){
					
						// if (columnIndex === 0) {
						// 	return {
						// 	rowspan: 5,
						// 	colspan: 1
						// 	};
							
						// } 
						// else if (columnIndex === 1) {
						// 	return [0, 0];
						// }
					// console.log('row._colspan[columnIndex]', row._colspan[columnIndex]);
					if(row._colspan[columnIndex])
						return row._colspan[columnIndex];
				}
			},
			tableRowClassName({row,index}){
				// console.log(row.id);
				let classes=[];
				// if(!row._isSummary && !row._summaryLevel) classes.push('regular-row');
				if(row._summaryLevel) classes.push('summary-level-'+row._summaryLevel);
				// if(row._summaryLevel == 1) {classes.push('summary-row-1');}
				// if(row._summaryLevel == 2) {classes.push('summary-row-2');}
				// if(row._summaryLevel == 1) {classes.push('summary-row-3');}
				// if(row._summaryLevel == 1) {classes.push('summary-row-1');}
				if(row._isSummary) classes.push('summary-row');
				return classes.join(' ');
			},
			tableRowClassName2({row,index}){
				// let classes=[];
				// if(!row._isSummary && !row._summaryLevel) classes.push('regular-row');
				// if(row._summaryLevel == 1) return {'background: rgb(1, 176, 224, 0.33)'} //classes.push('summary-level-'+row._summaryLevel);
				// if(row._isSummary) classes.push('summary-row');
				// return classes.join(' ');
			},
			summary(param){
				//это встроенным методом таблицы element.io
				const {summary, fields} = this.objReport;
				if(!summary) return {};
				// console.log('report summary', summary, fields);
				let result={}
				Object.keys(summary).forEach(key=>{
					result[key] = this.formatter(summary, fields[key], summary[key], true);
				})
				// console.log(result);
				// Возвращаем массивом. главное чтобы в summary были все столбцы
				return Object.values(result);

				/*
				//оригинал встроенным методом таблицы element.io (если получать итог таблицей, а не от бэкэкнда через summary). не удаляйте
				const { columns, data } = param;
				console.log('param ', param );

				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = 'ВСЕГО';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					// console.log('column.summary', column.summary);

					if(column.type == 'time'){
						let summ = '';
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)){
									summ = Math.round(prev) + Math.round(curr);
									return summ;
								}
							}, 0);
						}
						sums[index] = this.formatSecondstoMinutes(summ);
						//console.log('sums[index]', sums[index] );
					} 
					
					else if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						
							if(!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
					} else {
						sums[index] = 'N/A';
					}
				});

				return sums;
				*/
			}
			
		},
		mounted(){
			
		}
	}
</script>
<style scoped>
	.ReReports >>> .tableReports .table tr:hover {cursor:default;}
	.ReReports >>> .tableReports .table tbody tr:hover td{background: rgb(1, 176, 224, 0.33);}
	.ReReports >>> .tableReports .table tbody tr.summary-row {background: rgb(1, 176, 224, 0.33);}
	.ReReports >>> .tableReports .table tbody tr.summary-row.summary-row-9 {font-weight: bolder;}
	/* .ReReports >>> .tableReports .el-table__body-wrapper tbody tr.regular-row:last-child::after {
		content: '';
		position: absolute;
		background: #01B0E0;
		height: 3px;
		width: 100%;
		bottom: 0;
		left: 0;
	} */
	/* .ReReports >>> .tableReports .el-table__body-wrapper tbody tr.summary-row-1 {background: rgb(1, 176, 224, 0.33);}
	.ReReports >>> .tableReports .el-table__body-wrapper tbody tr.summary-row-2 {background: lightgey;}
	.ReReports >>> .tableReports .el-table__body-wrapper tbody tr.summary-row-3 {background: lightblue;}
	.ReReports >>> .tableReports .el-table__body-wrapper tbody tr.summary-row-4 {background: lightgreen;}
	.ReReports >>> .tableReports .el-table__body-wrapper tbody tr.summary-row-5 {background: lightyellow;} */

</style>
